import React from 'react';
import { Skeleton } from '@components/main-components/skeleton/Skeleton';
import { MAX_MINIMIZED_RELEASES } from '.';

export const getRowSkeletons = (count: number) =>
  Array.from({ length: count }).map((_, i) => <RowSkeleton key={i} />);

function RowSkeleton() {
  return (
    <div className="relative flex h-14 w-full items-center gap-4 px-4">
      <Skeleton className="h-10 w-10 rounded-[6px]" />
      <div className="flex flex-col gap-1">
        <Skeleton className="h-4 w-[180px] rounded-[6px]" />
        <Skeleton className="h-3 w-[71px] rounded-[6px]" />
      </div>
    </div>
  );
}

export const PreviewSkeleton = () => (
  <div className="relative flex max-h-screen transform-gpu flex-col overflow-hidden rounded-lg bg-white shadow-tertiary">
    <Skeleton className="relative h-[72px] w-full p-4 md:h-[138px]" />
    {getRowSkeletons(MAX_MINIMIZED_RELEASES)}
  </div>
);
